import { render, staticRenderFns } from "./CsText.vue?vue&type=template&id=33405113&"
import script from "./CsText.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsText.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports